import { Stack, Typography } from '@mui/material'
import { ActivityIndicator } from 'components/Shared/ActivityIndicator'
import { ErrorIndicator } from 'components/Shared/ErrorIndicator'
import { format } from 'date-fns'
import {
  CreditsWageredByHourChart,
  type DataItem,
} from './CreditsWageredByHourChart'
import { useGetCreditsWageredByHour } from 'hooks/api/Reports/useGetCreditsWageredByHour'
import { useSetLe } from 'stores/useSetLe'
import { GamingReportsHeader } from '../GamingReportsHeader'
import { useState } from 'react'
import { WeekRangeSelect } from 'components/WeekRangeSelect'
import { getReportStartAndEndDates } from 'utils/util'
import { useCurrentCorporateAccountStore } from 'stores/useCurrentCorporateAccountStore'
import { getLEIdsByPermission } from 'utils/permissions'
import { useSetMe } from 'stores/useMeQuery'

export const CreditsWageredByHourPage = () => {
  const { passedLe } = useSetLe()
  const { passedMe } = useSetMe()
  const meQuery = passedMe
  const selectedCorporateAccountId =
    useCurrentCorporateAccountStore().currentCorporateAccountId
  const [numDays, setNumDays] = useState<string>('56')

  // Get LE Ids for the permission the user has access to
  const leIdsByPermission: number[] = getLEIdsByPermission(
    meQuery.data,
    selectedCorporateAccountId,
    'gamingReportsPermission'
  )

  const dates = getReportStartAndEndDates(Number(numDays) / 7, 1)
  const calcStartDate = dates.startDate
  const endDate = dates.endDate

  const [, setStartDate] = useState<Date>(calcStartDate)

  const reportQuery = useGetCreditsWageredByHour({
    licensedEstablishmentId: Number(passedLe?.id),
    startDate: calcStartDate,
    endDate,
    enabled: !!passedLe?.id,
  })

  // Sort the start/end time so all three week filters display the same order
  reportQuery.data?.metrics.sort((a, b) => a.hour - b.hour)

  const formattedStartDate = format(calcStartDate, 'MM/dd/yyyy')
  const formattedEndDate = format(endDate, 'MM/dd/yyyy')

  return (
    <GamingReportsHeader currentTab={'2'}>
      {leIdsByPermission.length !== 0 && (
        <WeekRangeSelect
          label={`Weeks of: ${formattedStartDate} - ${formattedEndDate}`}
          numDays={numDays}
          setStartDate={setStartDate}
          setNumDays={setNumDays}
          displayWeeks={[4, 8, 16]}
        >
          <Stack spacing={4}>
            {reportQuery.isPending && reportQuery.isFetching && (
              <ActivityIndicator />
            )}
            {reportQuery.isError && <ErrorIndicator />}
            {reportQuery.data &&
              (reportQuery.data.metrics.length === 0 ? (
                <Typography variant="h4"></Typography>
              ) : (
                <CreditsWageredByHourChart
                  data={reportQuery.data.metrics.map(
                    (item) =>
                      ({
                        hour: Number(item.hour),
                        amount: Number(item.amount),
                        percentage: Number(item.percentage),
                      }) satisfies DataItem
                  )}
                />
              ))}
          </Stack>
        </WeekRangeSelect>
      )}
    </GamingReportsHeader>
  )
}
